"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../styles/theme"));
const circularGraph_1 = __importDefault(require("../../components/circularGraph/circularGraph"));
const installmentRows_1 = __importDefault(require("../../components/installmentRows/installmentRows"));
const loanStyles_1 = __importDefault(require("./loanStyles"));
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const text_1 = __importStar(require("../../components/text/text"));
const homeApplication_1 = __importDefault(require("../home/homeApplication"));
const homeWarningCards_1 = __importDefault(require("../../components/messageCards/homeWarningCards"));
const LoanActive = ({ activeLoan, ongoingLoanApplication, warnings, npsSurvey, submittedRating, }) => {
    const navigation = (0, useAppNavigation_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    let content = react_1.default.createElement(react_native_1.View, null);
    if (activeLoan) {
        const { installments } = activeLoan;
        let firstNotPaidInstallment;
        let installmentRows = null;
        if (installments) {
            firstNotPaidInstallment = installments.find((installment) => installment.status !== 'PAID');
            installmentRows = react_1.default.createElement(installmentRows_1.default, { installments: installments });
        }
        content = (react_1.default.createElement(react_native_1.View, { style: loanStyles_1.default.boxContainer },
            react_1.default.createElement(circularGraph_1.default, { activeLoan: activeLoan }),
            react_1.default.createElement(react_native_1.View, { style: [] }, firstNotPaidInstallment !== undefined ? (react_1.default.createElement(primaryButton_1.default, { disabled: false, title: `PAY INSTALLMENT #${firstNotPaidInstallment.id} NOW`, onPress: () => navigation.navigate(screenConstants_1.PAYMENT_SUMMARY_SCREEN, {
                    installment: firstNotPaidInstallment,
                }), eventName: "active_loan_pay_now" })) : null),
            react_1.default.createElement(react_native_1.View, { style: loanStyles_1.default.subtileMargin },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY_DARK }, t('loanActive.repayment_plan')),
                installmentRows)));
    }
    else if (!ongoingLoanApplication) {
        content = react_1.default.createElement(homeApplication_1.default, null);
    }
    else {
        content = (react_1.default.createElement(homeWarningCards_1.default, { submittedRating: submittedRating, activeLoan: activeLoan, npsSurvey: npsSurvey, ongoingLoanApplication: ongoingLoanApplication, warnings: warnings }, content));
    }
    return content;
};
exports.default = LoanActive;
